import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../ModalDialog';
import './_styles_/IdlePopup.css';

IdlePopup.propTypes = {
    onUserActive: PropTypes.func.isRequired,
    popupOffsetInMins: PropTypes.number.isRequired,
};

function IdlePopup(props) {
    const {
        onUserActive,
        popupOffsetInMins,
    } = props;
    const { t } = useTranslation();
    const idleDate = new Date(Date.now() + popupOffsetInMins * 60000);
    const message = t('misc.idle-popup-messaage');
    const timeMessage = t('misc.idle-popup-time-message', { mins: popupOffsetInMins, time: idleDate.toLocaleTimeString() });
    return (
        <ModalDialog onCancel={onUserActive}>
            <div className="idle-popup-dialog" role="dialog" aria-modal>
                <div className="message" aria-label={message}>{message}</div>
                <div className="time-message" aria-label={timeMessage}>{timeMessage}</div>
                <div className="buttons">
                    <button type="button" className="ok-button button-filled-red button" onClick={onUserActive}>{t('button.i-am-alive')}</button>
                </div>
            </div>
        </ModalDialog>
    );
}

export default IdlePopup;
